module.exports = __webpack_public_path__ + "img/hr-fluid-wagon-5.eef19994.png";